/**
 * 判断是否为手机端环境
 */
const isMobileEnv = process.env.PLATFORM === 'MOBILE'
console.log('env', process.env, process.env.PLATFORM)
/**
 * 处理后台传过来的图片id
 */
const handleImgPath = imgId => {
  if (imgId) {
    if (/^http+/.test(imgId)) {
      return imgId
    } else {
      return `${location.origin}/zhengpin/commonController.do?viewFile&fileid=${imgId}`
    }
  } else {
    return ''
  }
}
/**
 * html剔除富文本标签，留下纯文本
 */
const getSimpleText = richText => {
  if (richText) {
    var re1 = new RegExp('<.+?>', 'g') // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
    var msg = richText.replace(re1, '') // 执行替换成空字符
    return msg
  } else {
    return ''
  }
}
/**
 * 格式化富文本图片显示
 */
const formatRichTextImage = richText => {
  if (richText) {
    return richText.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, (match, capture) => {
      return `<img src="${capture}" style="width:100%;height:auto;" />`
    })
  } else {
    return ''
  }
}
// 格式化时间到年月日
const formatDate = date => {
  if (date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()

    return [year, month, day].map(formatNumber).join('-')
  } else {
    return ''
  }
}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}
export default {
  isMobileEnv,
  handleImgPath,
  getSimpleText,
  formatRichTextImage,
  formatDate
}



// WEBPACK FOOTER //
// ./src/utils/index.js